export default {
  MOBILE: {
    CONDITION: 'screen and (max-width: 720px)',
    TYPE: 'isMobile',
  },
  TABLET: {
    CONDITION: 'screen and (min-width: 721px) and (max-width: 1199px)',
    TYPE: 'isTablet',
  },
  DESKTOP: {
    CONDITION: 'screen and (min-width: 1200px)',
    TYPE: 'isDesktop',
  },
};
